﻿<template>
    <b-row class="product-brief">
        <b-col v-for="(product, index) in products"
               :key="index"
               cols="3"
               @click="updateProductId(product)"
               class="cursor-pointer product-brief-mobile">
            <b-card class="border rounded-4"
                    :img-src="product.default_picture_model.image_url"
                    :img-alt="product.default_picture_model.alternate_text"></b-card>
            <b-card class="border-0">
                <b-card-text>
                    <h5>{{ $t('part') }} #: {{ product.sku }}</h5>
                    <h6>{{ product.name }}</h6>
                </b-card-text>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
    import { CATEGORY_SITE } from '@/constants/products-info';

    export default {
        name: 'product-brief',

        data() {
            return {
                productId: null,
                categoryId: null
            }
        },

        props: {
            products: {
                type: Array,
                required: true
            }
        },

        watch: {
            productId(newId) {
                this.$emit('updateProduct', newId);
            }
        },

        methods: {
            updateProductId(product) {
                this.categoryId = product.breadcrumb.category_breadcrumb[CATEGORY_SITE].id;
                this.productId = product.id
                this.$router.push({ name: 'single-product', query: { categoryId: this.categoryId }, params: { productId: this.productId } })
            }
        }
    }
</script>